import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-generic-gallery-item',
  templateUrl: './generic-gallery-item.component.html',
  styleUrls: ['./generic-gallery-item.component.scss']
})
export class GenericGalleryItemComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }

}
